"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonolithGlobalHeadersService = void 0;
var CommonService_decorator_1 = require("../../core/decorators/CommonService.decorator");
var CoreGlobalHeaders_service_1 = require("../../core/services/CoreGlobalHeaders.service");
var LegacyProfileTeamSite_service_1 = require("./LegacyProfileTeamSite.service");
var helper_1 = require("../helper");
var Http_service_1 = require("../../core/services/http/Http.service");
var MonolithGlobalHeadersService = /** @class */ (function (_super) {
    __extends(MonolithGlobalHeadersService, _super);
    function MonolithGlobalHeadersService(httpService, legacyProfileTeamSiteService, seismicHelper) {
        var _this = _super.call(this, httpService) || this;
        _this.httpService = httpService;
        _this.legacyProfileTeamSiteService = legacyProfileTeamSiteService;
        _this.seismicHelper = seismicHelper;
        return _this;
    }
    MonolithGlobalHeadersService.prototype.getGlobalHeaders = function (profileVersionId) {
        var headers = __assign({}, _super.prototype.getGlobalHeaders.call(this));
        // TODO: Turn this into a separate interceptor that is only available in monolith as this will not be needed anywhere else
        // This actually may be specific to the JsonApiService API calls as well, I need to investigate more
        headers.SeismicClientName = this.seismicHelper.getClientType();
        if (profileVersionId) {
            headers.ProfileVersionId = profileVersionId;
        }
        else {
            headers.ProfileVersionId =
                this.legacyProfileTeamSiteService.profileVersionIdNewsCenter ||
                    this.legacyProfileTeamSiteService.profileVersionId ||
                    '';
            headers.TeamSiteId =
                this.legacyProfileTeamSiteService.teamSiteId ||
                    this.legacyProfileTeamSiteService.teamSiteIdInContentManager ||
                    '';
        }
        // TODO: Turn this into a separate interceptor that is only available in monolith as this will not be needed anywhere else
        if (window.EmbeddedPage && window.EmbeddedPage.seismicIntegratorContext) {
            var context = JSON.parse(window.EmbeddedPage.seismicIntegratorContext);
            context.ContextName = this.encodeHeader(context.ContextName);
            context.ContextType = this.encodeHeader(context.ContextType);
            context.ContextTypePlural = this.encodeHeader(context.ContextTypePlural);
            headers.SeismicIntegratorContext = JSON.stringify(context);
        }
        else {
            if (typeof window.SeismicSFDCClient !== 'undefined') {
                headers.SeismicIntegratorContext = window.SeismicSFDCClient.Current.Salesforce.SeismicIntegratorContext;
            }
        }
        return headers;
    };
    MonolithGlobalHeadersService = __decorate([
        CommonService_decorator_1.CommonService('GlobalHeadersService', { alwaysInitialized: true }),
        __metadata("design:paramtypes", [Http_service_1.HttpService,
            LegacyProfileTeamSite_service_1.LegacyProfileTeamSiteService,
            helper_1.SeismicHelper])
    ], MonolithGlobalHeadersService);
    return MonolithGlobalHeadersService;
}(CoreGlobalHeaders_service_1.CoreGlobalHeadersService));
exports.MonolithGlobalHeadersService = MonolithGlobalHeadersService;
//# sourceMappingURL=MonolithGlobalHeaders.service.js.map